import React from 'react';

/**
 * Creates an object URL for the provided Blob/File and revokes it on cleanup.
 * Returns undefined when no source is provided.
 */
export default function useObjectUrl(
  source?: Blob | MediaSource | null
): string | undefined {
  const [url, setUrl] = React.useState<string>();

  React.useEffect(() => {
    if (!source) {
      setUrl(undefined);
      return;
    }

    const objectUrl = URL.createObjectURL(source);
    setUrl(objectUrl);

    return () => {
      URL.revokeObjectURL(objectUrl);
    };
  }, [source]);

  return url;
}
